// extracted by mini-css-extract-plugin
export var root = "BoxOption-module--root--SZk4N";
export var option = "BoxOption-module--option--yYa3-";
export var isActive = "BoxOption-module--isActive--gkSqO";